import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["thumbnail", "container", "iframe"];

  connect() {
    // Get Vimeo ID from data attribute
    this.vimeoId = this.element.dataset.videoPlayerVimeoId;
    this.playing = false;

    // Set up click handler on the thumbnail with proper binding
    this.playVideoHandler = this.playVideo.bind(this);
    this.thumbnailTarget.addEventListener("click", this.playVideoHandler);

    // Set up message listener for coordinating multiple videos
    this.messageHandler = this.handleMessage.bind(this);
    window.addEventListener("message", this.messageHandler);
  }

  playVideo() {
    // Show the video container
    this.containerTarget.classList.remove("hidden");

    // Hide the thumbnail
    this.thumbnailTarget.classList.add("hidden");

    // Set the iframe source with autoplay parameter
    this.iframeTarget.src = `https://player.vimeo.com/video/${this.vimeoId}?autoplay=1&api=1&color=3693d0`;
    this.playing = true;

    // Notify other videos to pause
    this.dispatch("videoStarted", { detail: { id: this.vimeoId } });
  }

  handleMessage(event) {
    // Only process messages from Vimeo
    if (!event.origin.match(/vimeo\.com/)) return;

    try {
      const data = JSON.parse(event.data);

      // Track play/pause state
      if (data.event === "play") {
        this.playing = true;
        // Notify other videos to pause
        this.dispatch("videoStarted", { detail: { id: this.vimeoId } });
      } else if (data.event === "pause") {
        this.playing = false;
      }
    } catch (e) {
      // Not a JSON message, ignore
    }
  }

  pauseVideo() {
    if (this.playing && this.iframeTarget.contentWindow) {
      this.iframeTarget.contentWindow.postMessage(
        JSON.stringify({ method: "pause" }),
        "https://player.vimeo.com"
      );
      this.playing = false;
    }
  }

  videoStarted(event) {
    // If another video started playing and it's not this one, pause this video
    if (event.detail.id !== this.vimeoId) {
      this.pauseVideo();
    }
  }

  disconnect() {
    // Clean up event listeners
    this.thumbnailTarget.removeEventListener("click", this.playVideoHandler);
    window.removeEventListener("message", this.messageHandler);

    // Pause video if playing when controller disconnects
    if (this.playing) {
      this.pauseVideo();
    }
  }
}
